import { Map } from 'immutable';
import {
  CLEAR_SUCCESS,
  CREATE_SUCCESS,
  REQUEST,
  REQUEST_BY_ID,
  REQUEST_BY_ID_SUCCESS,
  REQUEST_INFO,
  REQUEST_INFO_SUCCESS,
  REQUEST_LOCATIONS,
  REQUEST_LOCATIONS_SUCCESS,
  REQUEST_PROVINCES,
  REQUEST_PROVINCES_SUCCESS,
  REQUEST_REGISTERS_SUCCESS,
  REQUEST_SUCCESS,
  UPDATE_FILTERS,
} from './users.actionTypes';

const initialState = Map().merge({
  users: [],
  user: {},
  registers: [],
  filters: {
    page: 0,
    search: {},
    rowsPerPage: 10,
    order: 'asc',
    orderBy: 'tipo',
    selected: []
  },
  success: false,
  isLoading: false,
  userInfo: {},
  provinces: [],
  locations: [],
});

const usersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REQUEST:
      return state.merge({
        users: [
          ...initialState.get('users')
        ],
        user: {
          ...initialState.get('user')
        },
        filters: {
          ...initialState.get('filters')
        },
        isLoading: true,
      });
    case REQUEST_SUCCESS:
      return state.merge({
        users: payload.users,
        isLoading: false,
      });
    case REQUEST_BY_ID:
      return state.merge({
        user: {
          ...initialState.get('user')
        }
      });
    case REQUEST_BY_ID_SUCCESS:
      return state.merge({
        user: payload.user
      });
    case REQUEST_INFO:
      return state.merge({
        userInfo: {
          ...initialState.get('userInfo')
        }
      });
    case REQUEST_INFO_SUCCESS:
      return state.merge({
        userInfo: payload.userInfo
      });
    case CREATE_SUCCESS:
      return state.merge({
        success: true,
        user: {
          ...payload.user
        }
      });
    case CLEAR_SUCCESS:
      return state.merge({
        success: false
      });
    case UPDATE_FILTERS:
      return state.merge({
        filters: {
          ...state.get('filters'),
          ...payload.filters
        }
      });
    case REQUEST_REGISTERS_SUCCESS:
      return state.merge({
        registers: payload.registers
      });
    case REQUEST_PROVINCES:
      return state.merge({
        provinces: {
          ...initialState.get('provinces')
        }
      });
    case REQUEST_PROVINCES_SUCCESS:
      return state.merge({
        provinces: payload.provinces
      });
    case REQUEST_LOCATIONS:
      return state.merge({
        locations: {
          ...initialState.get('locations')
        }
      });
    case REQUEST_LOCATIONS_SUCCESS:
      return state.merge({
        locations: payload.locations
      });
    default:
      return state;
  }
};

export default usersReducer;



// WEBPACK FOOTER //
// ./src/state/users/users.reducer.js